module.exports = __webpack_public_path__ + "static/media/Developmentbanner@2x.59a5f14b.png";